module.exports = __webpack_public_path__ + "img/num.783a957c.png";